// import React from 'react';
// import { UserPlus, Upload, Filter, ChevronDown, ChevronUp } from 'lucide-react';

// const SearchAndFilters = ({
//   searchTerm,
//   setSearchTerm,
//   filterStatus,
//   setFilterStatus,
//   filterDepartment,
//   setFilterDepartment,
//   isFilterOpen,
//   setIsFilterOpen,
//   departments,
//   onImportClick,
//   onCreateClick
// }) => {
//   return (
//     <>
//       <div className="flex gap-2 mb-2">
//         <div className="relative flex-1 min-w-0">
//           <input
//             type="text"
//             placeholder="Search users..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="w-full py-2 pr-4 text-sm text-white border rounded-lg pl-9 bg-richblue-600/20 border-blue-700/80 placeholder-blue-400/40 focus:outline-none focus:ring-2 focus:ring-blue-700"
//           />
//           <svg className="absolute left-2.5 top-2.5 h-4 w-4 text-blue-400/60" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//           </svg>
//         </div>
//         <button
//           onClick={() => setIsFilterOpen(!isFilterOpen)}
//           className="flex items-center gap-1.5 px-3 py-2 text-sm text-blue-300 border rounded-lg sm:hidden bg-richblue-600/20 border-blue-700/80 hover:bg-blue-700/30"
//         >
//           <Filter className="w-4 h-4" />
//           {isFilterOpen ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
//         </button>
//         <div className="flex gap-1.5 sm:gap-2">
//           <button
//             onClick={onCreateClick}
//             className="flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-white transition-colors border rounded-lg sm:px-4 bg-blue-600/20 hover:bg-blue-600/40 border-blue-700/80"
//           >
//             <UserPlus className="w-4 h-4" />
//             <span className="hidden sm:inline">Create User</span>
//           </button>
//           <button
//             onClick={onImportClick}
//             className="flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-white transition-colors border rounded-lg sm:px-4 bg-blue-600/20 hover:bg-blue-600/40 border-blue-700/80"
//           >
//             <Upload className="w-4 h-4" />
//             <span className="hidden sm:inline">Import CSV</span>
//           </button>
//         </div>
//       </div>

//       <div className={`gap-2 sm:flex ${isFilterOpen ? 'flex flex-col' : 'hidden'}`}>
//         <select
//           value={filterStatus}
//           onChange={(e) => setFilterStatus(e.target.value)}
//           className="flex-1 px-3 py-2 text-sm text-white border rounded-lg bg-richblue-600/20 border-blue-700/80 focus:outline-none focus:ring-2 focus:ring-blue-700"
//         >
//           <option value="all">All Status</option>
//           <option value="ACTIVE">Active</option>
//           <option value="DEACTIVE">Deactive</option>
//         </select>
//         <select
//           value={filterDepartment}
//           onChange={(e) => setFilterDepartment(e.target.value)}
//           className="flex-1 px-3 py-2 text-sm text-white border rounded-lg bg-richblue-600/20 border-blue-700/80 focus:outline-none focus:ring-2 focus:ring-blue-700"
//         >
//           {departments.map(dept => (
//             <option key={dept} value={dept}>
//               {dept === 'all' ? 'All Departments' : dept}
//             </option>
//           ))}
//         </select>
//       </div>
//     </>
//   );
// };

// export default SearchAndFilters;


import React from 'react';
import { UserPlus, Upload, Filter, ChevronDown, ChevronUp } from 'lucide-react';

const SearchAndFilters = ({
  searchTerm,
  setSearchTerm,
  filterStatus,
  setFilterStatus,
  filterDepartment,
  setFilterDepartment,
  isFilterOpen,
  setIsFilterOpen,
  departments,
  onImportClick,
  onCreateClick,
  theme
}) => {
  const isDark = theme === 'dark';

  // Theme-aware classes
  const bgInput = isDark ? 'bg-richblue-600/20' : 'bg-gray-100/80';
  const bgButton = isDark ? 'bg-blue-600/20 hover:bg-blue-600/40' : 'bg-gradient-to-br from-blue-500 to-blue-700 border-blue-400';
  const bgSelect = isDark ? 'bg-richblue-600/20' : 'bg-gray-100/80';
  
  const borderColor = isDark ? 'border-blue-700/80' : 'border-gray-300';
  const borderFocus = isDark ? 'focus:ring-2 focus:ring-blue-700' : 'focus:ring-2 focus:ring-blue-500';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  const textSecondary = isDark ? 'text-blue-300' : 'text-gray-700';
  //const textMuted = isDark ? 'text-blue-400/60' : 'text-gray-400';
  const placeholderColor = isDark ? 'placeholder-blue-400/40' : 'placeholder-gray-400';
  
  const hoverBg = isDark ? 'hover:bg-blue-700/30' : 'hover:bg-blue-200/50';
  const buttonText = isDark ? 'text-white' : 'text-gray-800';
  const iconColor = isDark ? 'text-blue-400/60' : 'text-gray-400';

  return (
    <>
      <div className="flex gap-2 mb-2">
        <div className="relative flex-1 min-w-0">
          <input
            type="text"
            placeholder="Search users..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={`w-full py-2 pr-4 text-sm ${textPrimary} ${bgInput} border ${borderColor} ${placeholderColor} rounded-lg pl-9 focus:outline-none ${borderFocus} transition-colors duration-300`}
          />
          <svg className={`absolute left-2.5 top-2.5 h-4 w-4 ${iconColor}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <button
          onClick={() => setIsFilterOpen(!isFilterOpen)}
          className={`flex items-center gap-1.5 px-3 py-2 text-sm border rounded-lg sm:hidden ${textSecondary} ${bgInput} ${borderColor} ${hoverBg} transition-colors duration-300`}
        >
          <Filter className="w-4 h-4" />
          {isFilterOpen ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
        </button>
        <div className="flex gap-1.5 sm:gap-2">
          <button
            onClick={onCreateClick}
            className={`flex items-center gap-1.5 px-3 py-2 text-sm text-white font-medium transition-colors border rounded-lg sm:px-4 ${buttonText} ${bgButton} ${borderColor} ${hoverBg} transition-colors duration-300`}
          >
            <UserPlus className="w-4 h-4" />
            <span className="hidden sm:inline">Create User</span>
          </button>
          <button
            onClick={onImportClick}
            className={`flex items-center gap-1.5 px-3 py-2 text-sm text-white font-medium transition-colors border rounded-lg sm:px-4 ${buttonText} ${bgButton} ${borderColor} ${hoverBg} transition-colors duration-300`}
          >
            <Upload className="w-4 h-4" />
            <span className="hidden sm:inline">Import CSV</span>
          </button>
        </div>
      </div>

      <div className={`gap-2 sm:flex ${isFilterOpen ? 'flex flex-col' : 'hidden'}`}>
        <select
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
          className={`flex-1 px-3 py-2 text-sm ${textPrimary} ${bgSelect} border ${borderColor} rounded-lg focus:outline-none ${borderFocus} transition-colors duration-300`}
        >
          <option value="all">All Status</option>
          <option value="ACTIVE">Active</option>
          <option value="DEACTIVE">Deactive</option>
        </select>
        <select
          value={filterDepartment}
          onChange={(e) => setFilterDepartment(e.target.value)}
          className={`flex-1 px-3 py-2 text-sm ${textPrimary} ${bgSelect} border ${borderColor} rounded-lg focus:outline-none ${borderFocus} transition-colors duration-300`}
        >
          {departments.map(dept => (
            <option key={dept} value={dept}>
              {dept === 'all' ? 'All Departments' : dept}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default SearchAndFilters;
